import { useEffect, useRef, useState } from 'libs/react';
import { ConsentChoice, injectGtmScript, loadConsentChoice, pushConsentDefault, pushConsentUpdate, pushConsentUpdateEvent, saveConsentChoice } from './gtmConsent';
/**
 * @function useGtmConsent
 * @since 1.0.0
 * Sets up Google Consent Mode v2 and injects the GTM container for a
 * domain, and drives the visibility of the cookie-consent banner. Shared
 * across every public screen so consent + GTM injection isn't duplicated.
 */
export function useGtmConsent(host, gtmId) {
    const [showBanner, setShowBanner] = useState(() => !!gtmId && loadConsentChoice(host) == null);
    const initializedGtmIdRef = useRef(null);
    useEffect(() => {
        if (!gtmId || initializedGtmIdRef.current === gtmId)
            return;
        initializedGtmIdRef.current = gtmId;
        pushConsentDefault();
        const stored = loadConsentChoice(host);
        if (stored) {
            pushConsentUpdate(stored);
        }
        injectGtmScript(gtmId);
        setShowBanner(stored == null);
    }, [gtmId]);
    function updateConsent(choice) {
        saveConsentChoice(host, choice);
        pushConsentUpdate(choice);
        pushConsentUpdateEvent();
        setShowBanner(false);
    }
    return { showBanner, updateConsent };
}
